// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M7eW","col":"styles_col__3sg_G"};